import { FC } from 'react';
import { Box } from '@mui/material';
import { observer } from 'mobx-react-lite';

import { useTrans } from '@libs/i18n';

import { CHAT_TOKENS } from '../constants';

interface SuggestedQuestionsProps {
  /** Called with the picked question — it fills the composer; the user sends it. */
  onQuestionSelect: (question: string) => void;
  disabled?: boolean;
}

export const SuggestedQuestions: FC<SuggestedQuestionsProps> = observer(
  ({ onQuestionSelect, disabled = false }) => {
    const { t } = useTrans();
    const questions = [
      t('chat.suggestedQuestions.question1'),
      t('chat.suggestedQuestions.question2'),
      t('chat.suggestedQuestions.question3'),
    ];

    return (
      <Box
        sx={{
          display: 'flex',
          flexWrap: 'wrap',
          justifyContent: 'center',
          gap: 1,
          mt: 2,
        }}
      >
        {questions.map((question, index) => (
          <Box
            key={index}
            component="button"
            type="button"
            disabled={disabled}
            onClick={() => onQuestionSelect(question as string)}
            sx={{
              px: 2,
              py: 1.125,
              borderRadius: '999px',
              border: `1px solid ${CHAT_TOKENS.hairline}`,
              backgroundColor: '#fff',
              color: '#333',
              fontFamily: 'inherit',
              fontSize: '0.781rem',
              cursor: disabled ? 'not-allowed' : 'pointer',
              opacity: disabled ? 0.6 : 1,
              transition:
                'background-color .16s ease, transform .14s ease, box-shadow .16s ease, border-color .16s ease',
              '&:hover': disabled
                ? {}
                : {
                    backgroundColor: CHAT_TOKENS.hover,
                    borderColor: '#DDD',
                    transform: 'translateY(-2px)',
                    boxShadow: '0 4px 12px rgba(0,0,0,.07)',
                  },
              '&:active': disabled ? {} : { transform: 'translateY(0) scale(.97)' },
            }}
          >
            {question}
          </Box>
        ))}
      </Box>
    );
  },
);
